<div class="diet-detail-container">
  <app-loading *ngIf="showLoading"></app-loading>
  <div class="diet-detail-nav-bar box">
    <div class="diet-detail-nav-bar-title">کالری</div>
    <div class="diet-detail-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="diet-detail-holder box">
    <div class="segment-control-container">
      <div class="segment-seperator1"></div>
      <div class="segment-seperator2"></div>
      <div class="selected-segment" id="selected-segment"></div>
      <div
        class="monthly-segment-title"
        id="segment2"
        (click)="segmentSelected(2)"
      >
        ماهانه
      </div>
      <div
        class="weekly-segment-title"
        id="segment1"
        (click)="segmentSelected(1)"
      >
        هفتگی
      </div>
      <div
        class="daily-segment-title"
        id="segment0"
        (click)="segmentSelected(0)"
      >
        روزانه
      </div>
    </div>
    <div class="calendar-holder">
      <div class="calendar-previous-diet img-holder" (click)="previousDays()">
        <img src="assets/plan/previousDay.png" />
      </div>
      <div class="calendar-current-diet-title">{{ title }}</div>
      <div class="calendar-next-diet img-holder" (click)="nextDays()">
        <img src="assets/plan/nextDay.png" />
      </div>
    </div>
    <app-profile-current-diet-chart
      class="diet-chart"
      [input]="barChartInput"
    ></app-profile-current-diet-chart>
    <div class="box cheat-table">
      <div class="detail-cell box">
        <div class="detail-cell-title">میانگین روزانه</div>
        <div class="detail-cell-description">{{ average }} کالری</div>
      </div>
    </div>
  </div>
</div>
